import { jobIsAvailableRouteGuard } from '@apps/customer/routeGuards';
import type { RouteRecordRaw } from 'vue-router';

export const SELECT_PACKAGE_PAGE = 'customer-select-package';
export const SELECT_PACKAGE_DETAILS_PAGE = 'customer-package-details';
export const EDIT_CART_PACKAGE = 'customer-edit-cart-package';

const routes: RouteRecordRaw[] = [
  {
    path: ':jobId',
    children: [
      {
        path: 'subject/:subjectId',
        children: [
          {
            name: SELECT_PACKAGE_PAGE,
            path: 'select-package/:imageId?',
            component: () => import('./pages/SelectPackage/SelectPackagePage.vue'),
            beforeEnter: [jobIsAvailableRouteGuard],
          },
          {
            name: SELECT_PACKAGE_DETAILS_PAGE,
            path: 'package-options/:packageIDs/:imageId?',
            component: () => import('./pages/PackageOptions/SelectPackageOptionsPage.vue'),
            beforeEnter: [jobIsAvailableRouteGuard],
          },
        ],
      },
      {
        name: EDIT_CART_PACKAGE,
        path: 'edit-cart-package/:cartPackageId',
        component: () => import('./pages/PackageOptions/EditCartPackage.vue'),
        beforeEnter: [jobIsAvailableRouteGuard],
      },
    ],
  },
];

export default routes;
